import { supabase } from './supabaseClient';

/**
 * Récupère TOUTES les lignes d'une requête en contournant le plafond de 1000
 * lignes de Supabase, via une pagination par .range().
 *
 * @param {(sb: typeof supabase) => any} buildQuery - construit la requête de base
 *   (sans .range()), p.ex. (sb) => sb.from('points').select('*').eq('profile_id', id)
 * @param {number} [pageSize=1000]
 * @returns {Promise<any[]>}
 */
export async function fetchAllRows(buildQuery, pageSize = 1000) {
  let from = 0;
  let all = [];
  while (true) {
    const { data, error } = await buildQuery(supabase).range(from, from + pageSize - 1);
    if (error) throw error;
    all = all.concat(data || []);
    if (!data || data.length < pageSize) break;
    from += pageSize;
  }
  return all;
}
